module.exports = __webpack_public_path__ + "img/item1_first.28a638ff.png";